<div class="container">
    <h2>Select your numbers</h2>
    <div class="ball-selector">
        <app-ball class="ball-selector-item" *ngFor="let ball of balls" [ball]="ball"></app-ball>
    </div>
</div>
